import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useConvexMutation } from './use-convex-mutation';

export interface Term {
  id: Id<'terms'>;
  name: string;
  startDate: string;
  endDate: string;
  createdAt: number;
}

export function useTerms() {
  const data = useQuery(api.director.terms.list);
  return { data: data ?? null, isLoading: data === undefined };
}

export function useCreateTerm() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.terms.create);
  return {
    isPending,
    mutateAsync: (args: { name: string; startDate: string; endDate: string }) =>
      mutateAsync(args),
  };
}

export function useRemoveTerm() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.terms.remove);
  return {
    isPending,
    mutateAsync: (termId: Id<'terms'>) => mutateAsync({ termId }),
  };
}
